import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { AUTH } from 'src/app/auth/components/login/types/login.interface';
import { AuthService } from 'src/app/auth/components/login/services/auth.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = sessionStorage.getItem(AUTH.TOKEN);
    if (token) {
      const modifiedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
      return next.handle(modifiedRequest);
    }
    return next.handle(request).pipe(
      catchError(err => {
        if (err.status === 500) {
          this.authService.logout();
          this.router.navigate(['/']);
          return throwError('Token is expired, please login again!');
        } else {
          return throwError(() => err);
        }
      })
    );
  }
}
